export default {
  misc: {
    location: {
      en: {
        virtualClassroom: 'Virtual Classroom',
        zinkerzPlatform: 'Zinkerz platform',
        hangouts: 'Meets',
        zoom: 'Zoom',
        inPerson: 'In-person'
      },
      es: {
        virtualClassroom: 'Aula virtual',
        zinkerzPlatform: 'Plataforma de Zinkerz',
        hangouts: 'Meets',
        zoom: 'Zoom',
        inPerson: 'Presencial'
      }
    }
  },
  payments: {
    statement: {
      en: {
        trigger: 'Statement',
        periodTitle: 'Statement period',
        recommended: 'Recommended',
        fromDate: 'From date',
        toDate: 'To date',
        optional: 'Optional',
        download: 'Download PDF',
        generating: 'Generating…',
        periods: {
          all: {
            title: 'All time',
            subtitle: 'Full history since enrollment — what parents ask for most often'
          },
          schoolYear: { title: 'This school year' },
          lastThreeMonths: { title: 'Last 3 months' },
          outstanding: {
            title: 'Outstanding only',
            subtitle: 'Unpaid & overdue invoices, no payment history'
          },
          custom: { title: 'Custom range' }
        },
        validation: {
          fromRequired: 'From date is required',
          toInvalid: 'To date is invalid',
          fromBeforeTo: 'From date must be on or before To date'
        },
        alert: {
          noStudents: 'Select at least one student to generate a statement',
          relationshipUnavailable: 'Unable to verify students for the selected parent. Please try again.',
          relationshipMismatch: 'Update the selected students to match the selected parent.',
          success: ({ count }) => `Generated ${count} statement(s).`,
          partial: ({ successCount, ids }) => `Generated ${successCount}; failed for: ${ids}.`,
          failure: ({ ids }) => `Couldn't generate statements for: ${ids}.`
        }
      },
      es: {
        trigger: 'Statement',
        periodTitle: 'Statement period',
        recommended: 'Recommended',
        fromDate: 'From date',
        toDate: 'To date',
        optional: 'Optional',
        download: 'Download PDF',
        generating: 'Generating…',
        periods: {
          all: {
            title: 'All time',
            subtitle: 'Full history since enrollment — what parents ask for most often'
          },
          schoolYear: { title: 'This school year' },
          lastThreeMonths: { title: 'Last 3 months' },
          outstanding: {
            title: 'Outstanding only',
            subtitle: 'Unpaid & overdue invoices, no payment history'
          },
          custom: { title: 'Custom range' }
        },
        validation: {
          fromRequired: 'From date is required',
          toInvalid: 'To date is invalid',
          fromBeforeTo: 'From date must be on or before To date'
        },
        alert: {
          noStudents: 'Select at least one student to generate a statement',
          relationshipUnavailable: 'Unable to verify students for the selected parent. Please try again.',
          relationshipMismatch: 'Update the selected students to match the selected parent.',
          success: ({ count }) => `Generated ${count} statement(s).`,
          partial: ({ successCount, ids }) => `Generated ${successCount}; failed for: ${ids}.`,
          failure: ({ ids }) => `Couldn't generate statements for: ${ids}.`
        }
      }
    }
  },
  profile: {
    payments: {
      en: {
        endOf: (str) => `End of ${str}`
      },
      es: {
        endOf: (str) => `Fines de ${str}`
      }
    },
    actions: {
      changeNotifications: {
        en: {
          reminderMinutes: (num) => `${num} min before`
        },
        es: {
          reminderMinutes: (num) => `${num} minutos antes`
        }
      }
    }
  },
  program: {
    plan: {
      infoModal: {
        en: {
          individualTopicLessons: ({ num, topic }) => `${num} Individual ${topic} Lessons`,
          totalTopicLessons: ({ num, topic }) => `${num} ${topic} Lessons`,
          groupalTopicLessons: ({ num, topic }) => `${num} Groupal ${topic} Lessons`,
          partDuration: ({ from, to }) => `From ${from} to ${to}`
        },
        es: {
          individualTopicLessons: ({ num, topic }) => `${num} Lecciones Individuales de ${topic}`,
          totalTopicLessons: ({ num, topic }) => `${num} Lecciones de ${topic}`,
          groupalTopicLessons: ({ num, topic }) => `${num} Lecciones Grupales de ${topic}`,
          partDuration: ({ from, to }) => `Desde ${from} al ${to}`
        }
      }
    }
  },
  modal: {
    childPlan: {
      en: {
        rangeDates: ({ from, to }) => `${from} to ${to}`
      },
      es: {
        rangeDates: ({ from, to }) => `${from} hasta ${to}`
      }
    },
    newplan: {
      recommendEducators: {
        en: {
          Individual: ({ name }) => `Recommend Individual ${name} educator`,
          Group: ({ name }) => `Select Groupal ${name} educator`
        },
        es: {
          Individual: ({ name }) => `Recomienda un educador para ${name}`,
          Group: ({ name }) => `Selecciona un educador de ${name} para clases Grupales`
        }
      },
      scheduledetails: {
        en: {
          totalLesson: ({ name }) => `Total individual ${name} lessons`,
          individualPerWeek: ({ name }) => `Individual ${name} lessons per week`,
          groupalPerWeek: ({ name }) => `Groupal ${name} lessons per week`,
          willHaveLessons: ({ total }) => `The student will have ${total} lessons`
        },
        es: {
          totalLesson: ({ name }) => `Total de lecciones individuales de ${name}`,
          individualPerWeek: ({ name }) => `Lecciones individuales de ${name} por semana`,
          groupalPerWeek: ({ name }) => `Lecciones grupales de ${name} por semana`,
          willHaveLessons: ({ total }) => `El estudiante tendrá ${total} lecciones`
        }
      },
      en: {
        indexFee: ({ num1, num2 }) => {
          const string =
            num1 +
            (['th', 'st', 'nd', 'rd'][((num1 % 100) - 20) % 10] ||
              ['th', 'st', 'nd', 'rd'][num1 % 100] ||
              ['th', 'st', 'nd', 'rd'][0])
          return `${string} out of ${num2}`
        }
      },
      es: {
        indexFee: ({ num1, num2 }) => `${num1}° de ${num2}`
      }
    },
    draftplan: {
      en: {
        individualLesson: ({ num, name }) => `${num} individual ${name} lessons`,
        groupalLesson: ({ num, topic }) => `${num} Groupal ${topic} Lessons`,
        rangeDates: ({ from, to }) => `FROM ${from} TO ${to}`,
        indexFee: ({ num1, num2 }) => `${num1}st out of ${num2}`
      },
      es: {
        individualLesson: ({ num, name }) => `${num} lecciones individuales de ${name}`,
        groupalLesson: ({ num, topic }) => `${num} lecciones grupales de ${topic}`,
        rangeDates: ({ from, to }) => `DESDE ${from} HASTA ${to}`,
        indexFee: ({ num1, num2 }) => `${num1}° de ${num2}`
      }
    },
    sendnotes: {
      en: {
        charsLeft: ({ num }) => `${num} chars left`
      },
      es: {
        charsLeft: ({ num }) => `Faltan ${num} caracteres`
      }
    },
    infolesson: {
      en: {
        haspending: ({ name, num }) => `${name} has ${num} pending lessons`
      },
      es: {
        haspending: ({ name, num }) => `${name} tiene ${num} lecciones pendientes`
      }
    },
    lesson: {
      scheduleConflict: {
        en: {
          chooseDateTopic: ({ topic }) => `Choose a date for your ${topic} lesson`
        },
        es: {
          chooseDateTopic: ({ topic }) => `Selecciona un horario para tu lección de ${topic}`
        }
      }
    }
  }
}
